<template>
    <v-container class="d-flex-column justify-center">
        <v-card :loading="loading" class="mt-2">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Ενηλικίωση Υπολοίπου Προμηθευτών</h1>
            <v-spacer/>
            Προμηθευτες:<v-chip label> {{ $tocurr(supplierDebt) }} </v-chip>
            <v-spacer/>
            Πελάτες: <v-chip label> {{ $tocurr(customerDebt) }} </v-chip>
          <v-container fluid class="mt-2">
          <v-row>
            <v-col cols="12" md="2" >
              <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Start date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                @input="menu = false"
                min="2021-11-01"
                :events="functionEvents"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-col cols="12" md="2" >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date2"
                  label="End date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                @input="menu2 = false"
                :events="functionEvents"
                min="2021-11-01"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="4" align="end" >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
            </v-row>
             <v-divider></v-divider>
            </v-container>
          </v-card-title>
          </v-card>
          <v-card class="mt-2">
           <v-tabs
             v-model="vtab"
            align-with-title
            >
          <v-tabs-slider color="primary"></v-tabs-slider>

          <v-tab
            v-for="item in vtabs"
            :key="item"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
          </v-card>


           <v-tabs-items class="mt-2 pa-2" v-model="vtab">
      <v-tab-item :key="vtabs[0]">
       <v-row fluid class="d-flex">
          <v-col >
          <v-card class="mt-5" tile>
            <v-card-title>
            <h1 class="mr-2 subheading grey--text">Ενηλικίωση υπολοίπου</h1>
            <v-spacer/>
            <v-chip label>
              {{
              $tocurr(supplierDebt)
              }}
            </v-chip>
            </v-card-title>
         <v-container fluid>
 <v-sheet class="d-flex flex-wrap bg-surface-variant justify-space-between">
          <v-col v-for="age in supplierAges" :key="age.Dates">
          <aged-accounts-table :supplier=true :search="search" :date_range="age.Dates" :accounts="age.Accounts"  :loading="loading"></aged-accounts-table>
          </v-col>
 </v-sheet>
    </v-container>
          </v-card>
          </v-col>
          </v-row>
      </v-tab-item>
      <v-tab-item :key="vtabs[1]">
       <v-row fluid class="d-flex">
          <v-col >
          <v-card class="mt-5" tile>
            <v-card-title>
            <h1 class="mr-2 subheading grey--text">Ενηλικίωση υπολοίπου</h1>
            <v-spacer/>
            <v-chip label>
              {{
              $tocurr(customerDebt)
              }}
            </v-chip>
            </v-card-title>
       <v-row fluid class="d-flex">
          <v-col cols=6 v-for="age in customerAges" :key="age.Dates">
          <aged-accounts-table :supplier=false  :search="search" :date_range="age.Dates" :accounts="age.Accounts"  :loading="loading"></aged-accounts-table>
          </v-col>
          </v-row>
          </v-card>
          </v-col>
          </v-row>
      </v-tab-item>
    </v-tabs-items>

    </v-container>
</template>

<script>

import AgedAccountsTable from "../components/AgedAccountsTable.vue";

export default {

  components: {
    AgedAccountsTable,
  },
  computed: {
    supplierDebt() {
        let sum = 0;
        for (var el in this.supplierAges) sum += this.sumField(this.supplierAges[el].Accounts, 'Account');
        return sum
    },
    customerDebt() {
        let sum = 0;
        for (var el in this.customerAges) sum += this.sumField(this.customerAges[el].Accounts, 'Account');
        return sum
    },
  },
  watch: {
    async date() {
      if (this.date != this.$route.query.startdate){
      this.$router.replace({
        name: "Expenses",
        query: { startdate: this.date, enddate: this.date2 },
      });
      await this.fetchData();
      }
    },
    async date2() {
      if (this.date2 != this.$route.query.enddate){
      this.$router.replace({
        name: "Expenses",
        query: { startdate: this.date, enddate: this.date2 },
      });
      await this.fetchData();
      }
    },
  },
  data() {
    return {
      date: this.isodate(new Date(new Date().setDate(1))), // (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      date2: this.isodate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      ),
      dialog: false,
      loading: true,
      debTotal: 0.0,
      tabTotal: 0.0,
      showBank: false,
      showCash: false,
      showCard: false,
      showCheque: false,
      ledger: [],
      ledgerTotals: 0,
      supplierAges: [],
      customerAges: [],
      tabs: [],
      vtab: null,
      vtabs: ['Προμηθευτες', 'Πελατες'],
      breakdown: {cash: 0, card: 0, check: 0, bank: 0},
      menu: false,
      menu2: false,
      search: "",
    }
  },
  async created() {
  /*
  if (this.$route.query.startdate) {
      this.date = this.$route.query.startdate;
    }
    if (this.$route.query.enddate) {
      this.date2 = this.$route.query.enddate;
    }
    */
    await this.fetchData();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    clickrow(item, _) {
      //this.$router.push('distributor/'+item.distributor_id)
    },
    isodate(date) {
      return date.toISOString().substr(0, 10);
    },
    async fetchData() {
    this.loading = true;
       try {
        let respS = await this.$api.get("/suppliers/aged-accounts", {
  /*        params: {
            start_date: this.date,
            end_date: this.date2,
            breakdown: true,
            weekly: 2023,
          },*/
        });
        // console.log(response.data);

        this.supplierAges = respS.data
        let respC= await this.$api.get("/customers/aged-accounts");
        // console.log(response.data);

        this.customerAges= respC.data
        this.loading = false;
      } catch (error) {
        console.error(error);
      }


    },
    functionEvents (date) {
      return this.debits.some(e => e.Date == date);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    },

};
</script>

<style>
.project.complete {
  border-left: 4px solid #3cd1c2;
}
.project.ongoing {
  border-left: 4px solid #ffaa2c;
}
.project.overdue {
  border-left: 4px solid #f83e70;
}
.v-chip.complete {
  background: #3cd1c2;
}
.v-chip.ongoing {
  background: #ffaa2c;
}
.v-chip.overdue {
  background: #f83e70;
}

.toupper input {
  text-transform: uppercase;
}
</style>ard
